import React, { useState } from 'react'

export interface ITextAreaProps {
  max_words?: number
  rows?: number
  cols?: number
  onChange: (content: string) => void
  content: string
  placeholder: string
  className?: string
}

export default function TextArea(props: ITextAreaProps) {
  const { max_words = 2000, content, onChange, placeholder, className } = props
  const [isFocused, setFocused] = useState(false)
  const handleChange = (evt: any) => {
    const { value = '' } = evt.target
    onChange(value)
  }

  const handleFocus = () => {
    setFocused(true)
  }
  const handleBlur = () => {
    setFocused(false)
  }

  return (
    <div className={`${className} text-area`}>
      <textarea
        onChange={handleChange}
        className={`textarea-simulator`}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        value={content}
        maxLength={max_words}
      />
      <div className="count-hint">
        还可以输入&nbsp;
        <span className="count">{max_words - content.length}</span>
        &nbsp;字
      </div>

      <style jsx>
        {`
          .text-area {
            width: 100%;
            position: relative;
            background-color: #f7f8fc;
            min-height: 200px;
            padding: 16px;
            box-sizing: border-box;
          }
          :global(.text-area .textarea-simulator) {
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            background: transparent;
            border-radius: 2px;
            color: #1f2129;
            font-size: 14px;
            line-height: 20px;
            resize: none;
            white-space: pre-wrap;
            border: none;
            outline: none;
          }
          :global(.text-area .textarea-simulator:focus) {
            border: none;
            outline: none;
          }
          .placeholder {
            position: absolute;
            color: #606370;
            top: 16px;
            left: 16px;
            visibility: ${isFocused || content !== '' ? 'hidden' : 'visible'};
          }

          .count-hint {
            text-align: right;
            color: #606370;
          }

          .count {
            color: #e65800;
          }
        `}
      </style>
    </div>
  )
}
